import FFT from 'fft.js';

export const bandpassFilter = (input, sampleRate, fLow, fHigh) => {
    // 确保输入数组长度是 2 的幂
    const nextPowerOfTwo = Math.pow(2, Math.ceil(Math.log2(input.length)));

    // 创建填充后的数组
    const paddedInput = new Float32Array(nextPowerOfTwo);
    paddedInput.set(input); // 复制原始数据

    // 使用填充后的数组长度创建 FFT
    const fft = new FFT(nextPowerOfTwo);
    const freqBins = fft.createComplexArray();
    const out = fft.createComplexArray();

    // 1. Forward FFT
    fft.realTransform(freqBins, paddedInput);
    fft.completeSpectrum(freqBins);

    // 2. Zero out frequencies outside band
    const binSize = sampleRate / nextPowerOfTwo;
    for (let i = 0; i < nextPowerOfTwo; i++) {
        const freq = i * binSize;
        if (freq < fLow || freq > fHigh) {
            freqBins[2 * i] = 0;
            freqBins[2 * i + 1] = 0;
        }
    }

    // 3. Inverse FFT
    fft.inverseTransform(out, freqBins);

    // 4. Return real part (忽略虚部)，并截断回原始长度
    const result = new Float32Array(input.length);
    for (let i = 0; i < input.length; i++) {
        const val = out[2 * i] / nextPowerOfTwo
        result[i] = parseFloat(val).toFixed(8); // 归一化
        // result[i] = parseFloat(val); // 归一化
    }
    return result;
}
export const getTopValuesBySecondItem = (data, count = 6) => {
    if (!Array.isArray(data) || data.length === 0) {
        return [];
    }

    // 创建数组的副本，避免修改原数组
    const sortedData = [...data];

    // 根据第二项（索引为1的元素）的值降序排序
    sortedData.sort((a, b) => b[1] - a[1]);

    // 返回前count个元素，如果数组长度小于count，则返回全部
    return sortedData.slice(0, count);
};
